module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img78.2d8b15d8.jpg";